import { create } from 'zustand';

import type { Logger } from '@/adapters/logger/types';
import type { SecureStoreAdapter } from '@/adapters/storage/types';

interface SettingsAdapters {
  secureStore: SecureStoreAdapter;
  logger: Logger;
}

interface SettingsState {
  allowMobileDataUpload: boolean;
  isLoading: boolean;
}

interface SettingsActions {
  loadSettings: () => Promise<void>;
  setAllowMobileDataUpload: (value: boolean) => Promise<void>;
}

const STORAGE_KEY = 'allowMobileDataUpload';

const createSettingsStore = (adapters: SettingsAdapters) =>
  create<SettingsState & SettingsActions>((set) => ({
    allowMobileDataUpload: false,
    isLoading: true,

    loadSettings: async () => {
      try {
        const stored = await adapters.secureStore.getItem(STORAGE_KEY);
        set({
          allowMobileDataUpload: stored === 'true',
          isLoading: false,
        });
      } catch (e) {
        adapters.logger.captureException(e);
        set({ isLoading: false });
      }
    },

    setAllowMobileDataUpload: async (value: boolean) => {
      set({ allowMobileDataUpload: value });
      try {
        await adapters.secureStore.setItem(STORAGE_KEY, String(value));
      } catch (e) {
        adapters.logger.captureException(e);
      }
    },
  }));

export { createSettingsStore };
export type { SettingsAdapters, SettingsActions, SettingsState };
